var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UmbracoImage',_vm._b({staticClass:"c-umbraco-image-ext",attrs:{"image-class-names":_vm.imageClasses}},'UmbracoImage',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }